module.exports = __webpack_public_path__ + "img/worldWrapper.e2fdcc76.svg";